import script from "./EnvironmentConfigModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnvironmentConfigModal.vue?vue&type=script&setup=true&lang=ts"

import "./EnvironmentConfigModal.vue?vue&type=style&index=0&id=1ad7fc70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ad7fc70"]])

export default __exports__